module.exports = __webpack_public_path__ + "img/PAG313_L.bff0578b.png";